import * as React from 'react';

import { IxpLocale } from './ixp.locale';
import CardWithIcon from '../../Card/CardWithIcon';

import globalIcon from '../../Icon/global.svg';
import networkIcon from '../../Icon/network.svg';
import serversIcon from '../../Icon/servers.svg';
import ddosIcon from '../../Icon/ddos.svg';
import accessIcon from '../../Icon/access.svg';
import supportIcon from '../../Icon/support.svg';

interface IxpProps {
  locale: IxpLocale;
}

const Ixp: React.SFC<IxpProps> = ({ locale }) => {
  const renderCard = (icon: string, html: string) => (
    <div className="mb-3">
      <CardWithIcon icon={icon}>
        <span dangerouslySetInnerHTML={{ __html: html }} />
      </CardWithIcon>
    </div>
  );

  return (
    <>
      <h4 className="my-5 mt-md-6 font-weight-bold">{locale.title}</h4>
      <div className="row">
        <div className="col-12 col-lg-6">
          {renderCard(globalIcon, locale.connection)}
          {renderCard(serversIcon, locale.access)}
          {renderCard(accessIcon, locale.address)}
        </div>
        <div className="col-12 col-lg-6">
          {renderCard(networkIcon, locale.vlan)}
          {renderCard(ddosIcon, locale.filtering)}
          {renderCard(supportIcon, locale.support)}
        </div>
      </div>
    </>
  );
};

export default Ixp;



// WEBPACK FOOTER //
// /www/client/src/components/ServicesPricingPage/Ixp/Ixp.tsx